import React, { useRef, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { Formik } from 'formik';

import SaveIcon from 'assets/customizeIcons/svg-icons/SaveIcon.js';
import { COLORS } from './Mobile';
import { formatCurrency } from 'pages/comptabilite/utils/functions';
import SvgArrowBack from "assets/customizeIcons/svg-icons/ArrowBackIcon";

const UpdateDevisLineModal = ({
	show = true,
	index,
	ligne,
	setVisible,
	setData,
	currency = 'EUR',
}) => {
	const [spinner, setSpinner] = useState(false);
	const formikRef = useRef(null);

	const closeModal = () => setVisible(false);

	const handleUpdateProduct = (values) => {
		const updatedLine = {
			...ligne,
			description: values.description,
			quantite: Number(values.quantite) || 0,
			prixUnitaireHT: Number(values.prixUnitaireHT) || 0,
		};

		setData((prev) => {
			const lignes = prev?.lignes || [];
			const newLignes = lignes.map((item, i) => (i === index ? updatedLine : item));

			const newTotalHT = newLignes.reduce(
				(sum, l) => sum + (Number(l.quantite) || 0) * (Number(l.prixUnitaireHT) || 0),
				0,
			);

			const tva = Number(prev.tva) || 0;
			const newMontantTVA = newTotalHT * (tva / 100);

			return {
				...prev,
				updated: true,
				lignes: newLignes,
				totalHT: newTotalHT,
				montantTVA: newMontantTVA,
				totalTTC: newTotalHT + newMontantTVA,
			};
		});

		closeModal();
	};

	return (
		<Modal show={show} onHide={() => { }} fullscreen>
			<Modal.Header className="bg-white border-bottom">
				<div
					style={{
						width: '100%',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
						gap: 10,
					}}
				>
					{/* Bouton Retour */}
					<div
						onClick={closeModal}
						style={{
							color: COLORS.INFO
						}}
					>
						<SvgArrowBack size={25} color={COLORS.INFO} />
						Retour
					</div>

					{/* Bouton Mettre à jour */}
					<Button
						onClick={() => handleUpdateProduct(formikRef.current.values)}
						disabled={spinner}
						style={{
							height: 35,
							borderRadius: 8,
							display: 'flex',
							alignItems: 'center',
							gap: 8,
							padding: '0 16px',
							backgroundColor: COLORS.PRIMARY,
							border: 'none',
						}}
					>
						<SaveIcon size={18} color={COLORS.WHITE} />
						<span>Enregistrer</span>
					</Button>
				</div>
			</Modal.Header>

			<Modal.Body className='p-0'>
				<div
					style={{
						padding: 20,
						maxWidth: 600,
						margin: '0 auto',
					}}>
					<Formik innerRef={formikRef}
						initialValues={{
							description: ligne?.description || '',
							quantite: ligne?.quantite || 1,
							prixUnitaireHT: ligne?.prixUnitaireHT || 0,
						}}
						validate={(values) => {
							const errors = {};
							if (!values.description) errors.description = 'Obligatoire';
							return errors;
						}}>
						{({ handleChange, values }) => (
							<Form>
								<h4
									style={{
										textAlign: 'center',
										marginBottom: 20,
										color: COLORS.DEFAULT,
									}}>
									Modifier la ligne de devis
								</h4>

								{/* DESCRIPTION */}
								<Form.Group style={{ marginBottom: 15 }}>
									<Form.Label>Description</Form.Label>
									<Form.Control
										as='textarea'
										rows={12}
										value={values.description}
										onChange={handleChange('description')}
										style={{
											backgroundColor: '#f9f9f9',
											borderRadius: 12,
											border: 'none',
											padding: 12,
										}}
									/>
								</Form.Group>

								{/* PRICE */}
								<Form.Group style={{ marginBottom: 15 }}>
									<Form.Label>Prix unitaire</Form.Label>
									<Form.Control
										type='number'
										value={values.prixUnitaireHT}
										onChange={handleChange('prixUnitaireHT')}
										style={{
											backgroundColor: '#f9f9f9',
											borderRadius: 12,
											border: 'none',
										}}
									/>
								</Form.Group>

								{/* QTY */}
								<Form.Group style={{ marginBottom: 20 }}>
									<Form.Label>Quantité</Form.Label>
									<Form.Control
										type='number'
										value={values.quantite}
										onChange={handleChange('quantite')}
										style={{
											backgroundColor: '#f9f9f9',
											borderRadius: 12,
											border: 'none',
										}}
									/>
								</Form.Group>

								<hr />

								{/* TOTAL */}
								<div
									style={{
										display: 'flex',
										justifyContent: 'space-between',
										marginBottom: 20,
									}}>
									<span>Total T.T.C</span>
									<strong style={{ fontSize: 18 }}>
										{formatCurrency(values.prixUnitaireHT * values.quantite)}
									</strong>
								</div>

								{/* SAVE */}
								{/* <Button
									onClick={() => handleUpdateProduct(values)}
									disabled={spinner}
									style={{
										width: '100%',
										height: 44,
										borderRadius: 10,
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										gap: 10,
										backgroundColor: COLORS.PRIMARY,
										border: 'none',
									}}>
									<SaveIcon size={20} color={COLORS.WHITE} />
									<span>Mettre à jour</span>
								</Button> */}
							</Form>
						)}
					</Formik>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default UpdateDevisLineModal;
